/**
 * Fetches training metadata for all available ML models. Used by the
 * "model freshness" banner above analytics cards.
 */

import { useQuery } from '@tanstack/react-query';
import { authFetch } from '@/lib/authFetch';
import type { ModelInfo } from './types';

export function useModelInfo() {
  return useQuery<ModelInfo[]>({
    queryKey: ['legacy-trust-ml', 'model-info'],
    queryFn: async () => {
      const resp = await authFetch('/api/legacy-trust-ml/model-info');
      if (!resp.ok) {
        throw new Error(`model-info failed: ${resp.status}`);
      }
      return resp.json();
    },
    staleTime: 60 * 60 * 1000, // 1 hour
  });
}

/** Pluck a single model's metadata by name. */
export function useModelInfoByName(name: string) {
  const all = useModelInfo();
  return {
    ...all,
    data: all.data?.find((m) => m.name === name) ?? null,
  };
}
